/**
 * A/B test for the cart drawer's "Standard Shipping" row (see snippets/cart-drawer.liquid).
 *
 * Variant A: shows the Standard Shipping row, folded into the displayed Total (the default look).
 * Variant B: hides the Standard Shipping row entirely -- the Total reflects merchandise only, and
 * the drawer's existing "Taxes and shipping calculated at checkout" note is the only shipping
 * messaging shown.
 *
 * The variant is assigned once per visitor (50/50) and persisted in localStorage so it stays
 * consistent for the whole test. The first time a visitor actually opens the drawer each session,
 * an exposure is reported to GA4 through the dataLayer -- the same window.dataLayer.push pattern
 * already used elsewhere in this theme (see layout/theme.liquid's "filters_applied_collection" and
 * assets/cart-drawer.js's "mini_cart_open"). Wiring that dataLayer event to an actual GA4 report is
 * a GTM container change (a GA4 event tag with a Custom Event trigger on "ab_test_exposure"), not
 * something this file can do on its own.
 */
(function () {
  var EXPERIMENT_NAME = 'cart_shipping_estimate';
  var VARIANT_STORAGE_KEY = 'dovetail:ab:' + EXPERIMENT_NAME;
  var EXPOSURE_STORAGE_KEY = VARIANT_STORAGE_KEY + ':exposed';

  function getOrAssignVariant() {
    var variant = localStorage.getItem(VARIANT_STORAGE_KEY);
    if (variant !== 'A' && variant !== 'B') {
      variant = Math.random() < 0.5 ? 'A' : 'B';
      localStorage.setItem(VARIANT_STORAGE_KEY, variant);
    }
    return variant;
  }

  function money(cents) {
    var amount = (Number(cents) || 0) / 100;
    try {
      return new Intl.NumberFormat(undefined, {
        style: 'currency',
        currency: window.shopCurrency || 'USD',
      }).format(amount);
    } catch (e) {
      return '$' + amount.toFixed(2);
    }
  }

  function applyVariant(variant) {
    document.querySelectorAll('[data-ab-shipping-row]').forEach(function (row) {
      row.hidden = variant === 'B';
    });

    document.querySelectorAll('[data-ab-total]').forEach(function (el) {
      var cents = variant === 'B' ? el.dataset.totalWithoutShipping : el.dataset.totalWithShipping;
      if (cents) el.textContent = money(cents);
    });
  }

  function trackExposureOnce(variant) {
    if (sessionStorage.getItem(EXPOSURE_STORAGE_KEY)) return;
    sessionStorage.setItem(EXPOSURE_STORAGE_KEY, '1');

    window.dataLayer = window.dataLayer || [];
    window.dataLayer.push({
      event: 'ab_test_exposure',
      experiment_name: EXPERIMENT_NAME,
      experiment_variant: variant,
    });
  }

  function run() {
    var variant = getOrAssignVariant();
    applyVariant(variant);
    trackExposureOnce(variant);
  }

  function init() {
    var cartDrawer = document.querySelector('cart-drawer');
    if (!cartDrawer) {
      run();
      return;
    }

    function maybeRun() {
      if (cartDrawer.classList.contains('active')) run();
    }

    // Re-applies on every drawer open, and again whenever the cart changes while it's open (the
    // drawer's contents get swapped wholesale on every update -- see assets/cart-drawer.js).
    new MutationObserver(maybeRun).observe(cartDrawer, { attributes: true, attributeFilter: ['class'] });
    maybeRun();

    if (typeof subscribe === 'function' && window.PUB_SUB_EVENTS) {
      subscribe(PUB_SUB_EVENTS.cartUpdate, maybeRun);
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
